/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IFormCustomCodeConfigurationScope extends ng.IScope {
        currentStep: Wars.Domain.Model.FormStep;
        save: any;
        getCustomButtons: any;
        buttonChanged: any;
        addPageLoad: any;
        addPageUnload: any;
        addButtonClickHandler: any;
        addCustomFunction: any;
        editor: AceAjax.Editor;
        removeFunction: any;
        insertFunctionCall: any;
        insertFieldGet: any;
        selectedFunction: Wars.Domain.Model.FormCodeFunction;
        selectFunction: any;
        addRow: any;
        insertFieldSet: any;
        getRowField: any;
        setRowField: any;
        removeRow: any;
        removeAllRows: any;
        loopThruRows: any;
        fieldsAvailableForSet: Wars.Domain.Model.Field[];
        customDivs: Wars.Domain.Model.Field[];
        rowsToAdd: Wars.Domain.Model.FormSection[];
        codes: Wars.Domain.Model.Codes.CodeGroup[];
        getFilteredFields: any;
        aceLoaded: any;
        addJQuerySelector: any;
        insertGetCodeValue: any;
        insertSaveFeature: any;
        insertRemoveFeature: any;
        insertGetNewFeature: any;
        insertGetFeatures: any;
        isListButton: boolean;
        processConfigurationId: string;
        gisDataStores: Wars.Domain.Model.Gis.GisDatastore[];
        form: Wars.Domain.Model.Form;
        addUrl:any;
        removeUrl:any;
        addCodeRow:any;
    }

    export class FormCustomCodeConfiguration implements IDirective {
        public link($scope: IFormCustomCodeConfigurationScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/inputForm/formCustomCodeConfiguration.html';
        public controller = [
            '$scope', 'formCodeFunctionService', 'growl', '$q', 'manageSystemCodesService', 'systemLevelService',
            'gisDatastoreService', 'formService', FormCustomCodeConfigurationController
        ];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            currentStep: "=",
            processConfigurationId: "=",
            form: "="
        };
    }

    declare var formCustomCodeConfigurationControllerSelf: FormCustomCodeConfigurationController;

    export class FormCustomCodeConfigurationController {
        constructor(private scope: IFormCustomCodeConfigurationScope,
            private formCodeFunctionService: services.FormCodeFunctionService,
            private growl: angular.growl.IGrowlService,
            private $q: angular.IQService,
            private manageCodeService: services.ManageSystemCodesService,
            private systemLevelService: services.SystemLevelService,
            private gisDataStoreService: services.GisDatastoreService,
            private formService: services.FormService) {

            scope.save = () => this.save();
            scope.getCustomButtons = () => this.getCustomButtons();
            scope.buttonChanged = () => this.buttonChanged();
            scope.addPageLoad = () => this.addPageLoad();
            scope.addPageUnload = () => this.addPageUnload();
            scope.addButtonClickHandler = () => this.addButtonClickHandler();
            scope.addCustomFunction = () => this.addCustomFunction();
            scope.insertFunctionCall = (f) => this.insertFunctionCall(f);
            scope.removeFunction = () => this.removeFunction();
            scope.aceLoaded = (e) => this.aceLoaded(e);
            scope.selectFunction = (f) => this.selectFunction(f);
            scope.insertFieldSet = (f) => this.insertFieldSet(f);
            scope.insertFieldGet = (f) => this.insertFieldGet(f);
            scope.addRow = (f) => this.addRow(f);
            scope.addCodeRow = (f) => this.addCodeRow(f);
            scope.getRowField = (r, f) => this.getRowField(r, f);
            scope.setRowField = (r, f) => this.setRowField(r, f);
            scope.loopThruRows = (f) => this.loopThruRows(f);
            scope.getFilteredFields = (f) => this.getFilteredFields(f);
            scope.removeRow = (f) => this.removeRow(f);
            scope.removeAllRows = (f) => this.removeAllRows(f);
            scope.addJQuerySelector = (f) => this.addJQuerySelector(f);
            scope.insertGetCodeValue = (c) => this.insertGetCodeValue(c);
            scope.insertSaveFeature = () => this.insertSaveFeature();
            scope.insertRemoveFeature = () => this.insertRemoveFeature();
            scope.insertGetNewFeature = (c) => this.insertGetNewFeature(c);
            scope.insertGetFeatures = (c) => this.insertGetFeatures(c);
            scope.addUrl= () => this.addUrl();
            scope.removeUrl = (c) => this.removeUrl(c);

            formCustomCodeConfigurationControllerSelf = this;

            var processCodes: Wars.Domain.Model.Codes.CodeGroup[];
            var systemCodes: Wars.Domain.Model.Codes.CodeGroup[];

            this.gisDataStoreService.getGisDatastores().then(r => {
                scope.gisDataStores = r;
            });

            $q.all([
                manageCodeService.getAllCodesForProcessConfiguration(this.scope.processConfigurationId).then(r => {
                    processCodes = r;
                }),
                this.systemLevelService.getSystemLevelCodes().then(
                    systemLevel => {
                        systemCodes = systemLevel.myCodeGroups;
                    })
            ]).then(() => {
                this.scope.codes = [];
                this.scope.codes.addRange(systemCodes);
                this.scope.codes.addRange(processCodes);
            });
        }

        private addFunction(type: Wars.Domain.Model.Codes.Enums.CustomCodeType) {
            var func = this.formCodeFunctionService.createFormCodeFunction();

            func.codeType = type;
            func.formStep = this.scope.currentStep;

            this.scope.currentStep.formCodeFunctions.push(func);

            this.formCodeFunctionService.saveAllChanges();
            this.selectFunction(func);
        }

        private loopThruRows(formSection: Wars.Domain.Model.FormSection) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.loopThruRows(processId,formId,formDataId,'" +
                formSection.objectSchema.uniqueIdentifier +
                "',function(row){\n\n}); /*  section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        public insertFieldSet(field: Wars.Domain.Model.Field) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.setField(processId,formId,formDataId,'" +
                field.schemaProperty.uniqueIdentifier +
                "',REPLACE_WITH_THE_VALUE_TO_SET); /*  field: " +
                field.schemaProperty.name +
                "*/ \n");
            this.save();
        }


        public insertFieldGet(field: Wars.Domain.Model.Field) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "var FIELD_VALUE = Elp.Api.Process.getField(processId,formId,formDataId,'" +
                field.schemaProperty.uniqueIdentifier +
                "'); /*  field: " +
                field.schemaProperty.name +
                "*/ \n");
            this.save();
        }

        public addRow(formSection: Wars.Domain.Model.FormSection) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.addRow(processId,formId,formDataId,'" +
                formSection.objectSchema.uniqueIdentifier +
                "'); /* section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        public addCodeRow(formSection: Wars.Domain.Model.FormSection) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.addRow(processId,formId,formDataId,'" +
                formSection.objectSchema.uniqueIdentifier +
                "',true); /* section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        private removeAllRows(formSection: Wars.Domain.Model.FormSection) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.removeAllRows(processId,formId,formDataId,'" +
                formSection.objectSchema.uniqueIdentifier +
                "'); /* section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        private selectFunction(func: Wars.Domain.Model.FormCodeFunction) {
            this.scope.selectedFunction = func;
            if (this.scope.editor) {
                this.scope.editor.setValue(func.javascript);
            }

            this.scope.fieldsAvailableForSet = Enumerable.from(this.scope.currentStep.formSections)
                .where(fs => fs.formSectionType === Wars.Domain.Model.Codes.Enums.FormSectionType.Standard)
                .selectMany(fs => fs.fields)
                .where(fs => fs.schemaProperty.propertyType !== Wars.Domain.Model.Codes.Enums.VariableType.None)
                .toArray();

            this.scope.customDivs = Enumerable.from(this.scope.currentStep.formSections)
                .where(fs => fs.formSectionType === Wars.Domain.Model.Codes.Enums.FormSectionType.Standard)
                .selectMany(fs => fs.fields)
                .where(fs => fs.type === Wars.Domain.Model.Codes.Enums.FieldType.CustomDiv)
                .toArray();

            this.scope.rowsToAdd = Enumerable.from(this.scope.currentStep.formSections)
                .where(fs => fs.formSectionType === Wars.Domain.Model.Codes.Enums.FormSectionType.List)
                .toArray();

            this.setIsListButton();
        }

        private setIsListButton() {
            this.scope.isListButton =
                this.scope.selectedFunction.codeType === Wars.Domain.Model.Codes.Enums.CustomCodeType.ButtonClick &&
                this.scope.selectedFunction.field.myFormSection.formSectionType ===
                Wars.Domain.Model.Codes.Enums.FormSectionType.List;
        }

        public removeRow(formSection: Wars.Domain.Model.FormSection) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Process.removeRow(processId,formId,formDataId,'" +
                formSection.objectSchema.uniqueIdentifier +
                "',ROW_ID_TO_REMOVE_GOES_HERE); /* section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        public addPageUnload() {
            if (Enumerable.from(this.scope.currentStep.formCodeFunctions)
                .any(f => f.codeType === Wars.Domain.Model.Codes.Enums.CustomCodeType.Unload)) {
                this.growl.error("An page unloaded function has already been added to this step");
            } else {
                this.addFunction(Wars.Domain.Model.Codes.Enums.CustomCodeType.Unload);;
            }
        }

        public insertFunctionCall(func: Wars.Domain.Model.FormCodeFunction) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert("Elp.Api.Helper.callFunction('" +
                func.id +
                "',processId,formId,formDataId); /* calls " +
                func.name +
                "*/ \n");
            this.save();
        }

        public buttonChanged() {
            if (Enumerable.from(this.scope.currentStep.formCodeFunctions)
                .count(f => f.field_id === this.scope.selectedFunction.field_id) >
                1) {
                this.growl.error("The selected button " +
                    this.scope.selectedFunction.field.schemaProperty.name +
                    " is already associated to a function.");

                this.scope.selectedFunction.field_id = null;
                this.scope.selectedFunction.field = null;
            } else {
                this.save();
            }

            this.setIsListButton();
        }

        private save() {
            this.formCodeFunctionService.saveAllChanges();
        }

        public removeFunction() {
            this.scope.selectedFunction.entityAspect.setDeleted();
            this.save();
        }

        public getCustomButtons() {
            var results = [];

            this.scope.currentStep.formSections.forEach(fs => {
                fs.fields.forEach(f => {
                    if (f.type === Wars.Domain.Model.Codes.Enums.FieldType.CustomButton) {
                        results.push(f);
                    }
                });
            });

            return results;
        }

        public addCustomFunction() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.CustomCodeType.CustomFunction);
        }

        public aceLoaded(editor: AceAjax.Editor) {
            this.scope.editor = editor;
            //console.log(this.scope.editor);
            //console.log(this);
        }

        public addPageLoad() {
            if (Enumerable.from(this.scope.currentStep.formCodeFunctions)
                .any(f => f.codeType === Wars.Domain.Model.Codes.Enums.CustomCodeType.Load)) {
                this.growl.error("An page loaded function has already been added to this step");
            } else {
                this.addFunction(Wars.Domain.Model.Codes.Enums.CustomCodeType.Load);
            }
        }

        public addButtonClickHandler() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.CustomCodeType.ButtonClick);
        }

        public getRowField(formSection: Wars.Domain.Model.FormSection, field: Wars.Domain.Model.Field) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert("\tElp.Api.Process.getEnumeratedRowValue('" +
                formSection.objectSchema.uniqueIdentifier +
                "','" +
                field.schemaProperty.uniqueIdentifier +
                "',row); /* section: " +
                formSection.objectSchema.name +
                "*/ \n");
            this.save();
        }

        public getFilteredFields(fields: Wars.Domain.Model.Field[]) {
            return fields.filter(f => {
                return f.schemaProperty.propertyType !== Wars.Domain.Model.Codes.Enums.VariableType.None;
            });
        }

        public addJQuerySelector(field: Wars.Domain.Model.Field) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert("$('#" +
                field.schemaProperty.uniqueIdentifier +
                "');/* Div:" +
                field.schemaProperty.name +
                "*/");
            this.save();
        }

        public setRowField(formSection: Wars.Domain.Model.FormSection, field: Wars.Domain.Model.Field) {
            if (this.scope.isListButton) {
                formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                    "Elp.Api.Process.setRowValue(processId,formId,formDataId,'" +
                    formSection.objectSchema.uniqueIdentifier +
                    "','" +
                    field.schemaProperty.uniqueIdentifier +
                    "',rowId,'REPLACE_WITH_THE_VALUE_TO_SET'); /* section: " +
                    formSection.objectSchema.name +
                    "*/ \n");;
            } else {
                formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                    "\tElp.Api.Process.setEnumeratedRowValue(processId,formId,formDataId,'" +
                    formSection.objectSchema.uniqueIdentifier +
                    "','" +
                    field.schemaProperty.uniqueIdentifier +
                    "',row,'REPLACE_WITH_THE_VALUE_TO_SET'); /* section: " +
                    formSection.objectSchema.name +
                    "*/ \n");;
            }

            this.save();
        }

        public insertGetNewFeature(gisDataStore: Wars.Domain.Model.Gis.GisDatastore) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.GisDatastore.getNewFeature('" +
                gisDataStore.id +
                "',processId,GEOMETRY_TYPE_GO_HERE,COORDINATES_GO_HERE); /* Gis Datastore: " +
                gisDataStore.name +
                "*/ \n");
            this.save();
        }

        public insertSaveFeature() {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.GisDatastore.getNewFeature(FEATURE_GOES_HERE); \n");
            this.save();
        }

        public insertRemoveFeature() {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.GisDatastore.removeFeature(FEATURE_GOES_HERE); \n");
            this.save();
        }

        public insertGetFeatures(gisDataStore: Wars.Domain.Model.Gis.GisDatastore) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.GisDatastore.getFeatures('" +
                gisDataStore.id +
                "',BOUNDING_BOX_GOES_HERE )\n.then(function(feature){ \n /*DO_SOMETHING*/ \n});" +
                " /* Gis Datastore: " +
                gisDataStore.name +
                "*/ \n");
            this.save();
        }

        public addUrl() {
            var url = this.formService.createUrl(this.scope.form);
            url.type = Wars.Domain.Model.Codes.Enums.UrlDependencyType.Javascript;
            this.scope.form.urlDependencies.push(url);
            this.save();
        }

        public removeUrl(url: Wars.Domain.Model.UrlDependency) {
            url.entityAspect.setDeleted();
            this.save();
        }

        public insertGetCodeValue(code: Wars.Domain.Model.Codes.CodeGroup) {
            formCustomCodeConfigurationControllerSelf.scope.editor.insert(
                "Elp.Api.Code.getCode('" +
                code.id +
                "',/* REPLACE_WITH_VALUE */);" +
                " /* Code Group: " +
                code.groupName +
                "*/ \n");
            this.save();
        }
    }
}

warsApp.registerDirective('FormCustomCodeConfiguration', []);